<template lang='pug'>
  base-card.rsv-card.component.actionable.container(
    :class='{ future: rsv.datetime.start.toDate().getDate() > date, pending: pending(rsv), canceled: canceled(rsv), inactive: inactive }'
  )
    rsv-stamp(
      :text='$t("CANCELED")'
      v-if='canceled(rsv)'
    )

    .time-count
      span.time
        span.icon
          time-icon
        span.text {{ `${rsv.datetime.start.toDate().getMonth() + 1}/${rsv.datetime.start.toDate().getDate()}` }} {{ rsv.datetime.start.toDate().toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3") }}
      .count {{ count + 1 }}/{{ total }}
    h4.business.snippet.ellipsis {{ business.name }}
    .service.ellipsis {{ rsv.service.title }}
    h5.duration {{ rsv.service.duration }} {{ $t('mins') }}
</template>

<script>
  import { db } from '@/main'
  import BaseCard from '@/components/base-card'

  export default {
    name: 'rsv-card.component',

    props: {
      rsv: Object,
      reservations: { type: Array, default: () => [] },
      i: Number
    },

    components: {
      BaseCard
    },

    data() {
      return {
        date: new Date(),
        business: {},
        service: {},
      }
    },

    firestore() {
      return {
        business: db.collection('businesses').doc( this.rsv.business_id ),
        service: db.collection('services').doc( this.rsv.service_id )
      }
    },

    computed: {
      rsvs() {
        return this.reservations.filter( r =>
          r.datetime.start.toDate().getDate() == this.rsv.datetime.start.toDate().getDate()
        )
      },

      count() {
        return this.rsvs.indexOf( this.rsv )
      },

      total() {
        return this.rsvs.length
      },

      inactive() {
        return this.rsv.datetime.end.toDate() < new Date()
      }
    },

    methods: {
      pending(r) {
        return r.status == 'Pending Cancellation'
      },

      canceled(r) {
        return r.status == 'Canceled'
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .base-card.future
    opacity .5

  .base-card.pending, .base-card.canceled
    border-color red
    border-width 1.5px

  .base-card.inactive
    background rgb( 245 245 245 )
    opacity .95
    
  .no-rsv
    .time-count
      display flex
      align-items center
      margin-bottom 16px
      .time
        .icon
          font-size 1.1em
          margin-right 4px
      .count
        margin-left auto
    h5
      // font-size .88em
    .base-card
      padding 12px
      height 100%
      box-sizing border-box
  .text
    font-weight bold
  
  .rsv-card
    font-size .9em
    padding 12px 12px
    text-align left
    display flex
    flex-direction column
    .time-count
      display flex
      align-items center
      margin-bottom 16px !important
      .time
        .icon
          font-size 1.1em
          margin-right 4px
      .count
        margin-left auto
    > *
      margin-bottom 8px

    .details
      margin-top 16px

    .service
      width 88px
      font-size 1.08em
      @media(min-width: 360px)
        width 112px
      @media(min-width: 420px)
        width 132px
      @media(min-width: 480px)
        width 144px
      @media(min-width: 640px)
        width 136px

    .duration
      margin-top auto
      margin-bottom 4px
      color rgb( 0 192 255 )

  .rsv-card.no-rsv
    height 88px
    min-width 160px
</style>
